// ================================================================
// cust2-swipe — swipe-to-reveal actions rooye radif-e moshtari (mobile/iOS)
// swipe az rast be chap => dokme-ha (Anrufen/E-Mail/Bearbeiten/Loeschen) az rast peydast
// ================================================================

const THRESHOLD = 55;
const H_LOCK = 10;

let startX = 0, startY = 0;
let curWrap = null;
let dir = null;
let openWrap = null;

function actionsWidth(wrap) {
  const p = wrap && wrap.querySelector('.cd-cust2-swipe-actions');
  const w = p ? p.offsetWidth : 0;
  return w > 0 ? w : 200;
}

function setTx(g, px) {
  g.style.transform = px ? ('translateX(' + px + 'px)') : '';
}

function closeOpen() {
  if (openWrap) {
    const g = openWrap.querySelector('.cd-cust2-swipe-body');
    if (g) setTx(g, 0);
    openWrap.classList.remove('cd-cust2-swipe-open');
    openWrap.classList.remove('cd-cust2-swiping');
    openWrap = null;
  }
}

export function initCust2Swipe(container) {
  container.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1) return;
    if (e.target.closest && e.target.closest('.cd-cust2-swipe-actions')) return;
    const wrap = e.target.closest && e.target.closest('.cd-cust2-swipe-wrap');
    if (openWrap && openWrap !== wrap) closeOpen();
    if (!wrap) return;
    curWrap = wrap;
    dir = null;
    const t = e.touches[0];
    startX = t.clientX; startY = t.clientY;
  }, { passive: true });

  container.addEventListener('touchmove', (e) => {
    if (!curWrap || e.touches.length !== 1) return;
    const t = e.touches[0];
    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    if (dir === null) {
      if (Math.abs(dx) > H_LOCK || Math.abs(dy) > H_LOCK) {
        dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      } else {
        return;
      }
    }
    if (dir !== 'h') return;

    if (e.cancelable) e.preventDefault();
    curWrap.classList.add('cd-cust2-swiping');
    const g = curWrap.querySelector('.cd-cust2-swipe-body');
    if (!g) return;
    const W = actionsWidth(curWrap);
    const base = curWrap.classList.contains('cd-cust2-swipe-open') ? -W : 0;
    let tx = base + dx;
    if (tx > 0) tx = 0;
    if (tx < -W) tx = -W;
    setTx(g, tx);
  }, { passive: false });

  const finish = () => {
    if (!curWrap) { dir = null; return; }
    const wrap = curWrap;
    const g = wrap.querySelector('.cd-cust2-swipe-body');
    wrap.classList.remove('cd-cust2-swiping');
    if (dir === 'h' && g) {
      const m = /translateX\((-?\d+(?:\.\d+)?)px\)/.exec(g.style.transform || '');
      const tx = m ? parseFloat(m[1]) : 0;
      if (tx <= -THRESHOLD) {
        setTx(g, -actionsWidth(wrap));
        wrap.classList.add('cd-cust2-swipe-open');
        openWrap = wrap;
      } else {
        setTx(g, 0);
        wrap.classList.remove('cd-cust2-swipe-open');
        if (openWrap === wrap) openWrap = null;
      }
    }
    curWrap = null; dir = null;
  };
  container.addEventListener('touchend', finish, { passive: true });
  container.addEventListener('touchcancel', finish, { passive: true });

  container.addEventListener('click', (e) => {
    if (!openWrap) return;
    if (e.target.closest && e.target.closest('.cd-cust2-swipe-open')) return;
    closeOpen();
  }, true);
}

export function closeCust2Swipe() {
  closeOpen();
}
